import React, { useState, useEffect } from 'react';

const NavMenuButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const bodyClickListener = (e) => {
    const isButton = !!e.target.closest('.site-header__menu-button');
    const isNav = !!e.target.closest('.site-header__nav');

    if (!isButton && !isNav && document.body.classList.contains('nav-menu-open')) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.body.classList.toggle('nav-menu-open', isOpen);
    document.querySelector('body').addEventListener('click', bodyClickListener);

    return () => document.querySelector('body').removeEventListener('click', bodyClickListener);
  }, [isOpen]);

  return (
    <button className="site-header__menu-button" onClick={() => setIsOpen(!isOpen)}>
      <span />
      <span />
      <span />
      <span />
    </button>
  );
};

export default NavMenuButton;
